import { render, staticRenderFns } from "./api_export.vue?vue&type=template&id=6e1a2d10&scoped=true&"
import script from "./api_export.vue?vue&type=script&lang=js&"
export * from "./api_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1a2d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1a2d10')) {
      api.createRecord('6e1a2d10', component.options)
    } else {
      api.reload('6e1a2d10', component.options)
    }
    module.hot.accept("./api_export.vue?vue&type=template&id=6e1a2d10&scoped=true&", function () {
      api.rerender('6e1a2d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/api/api_export.vue"
export default component.exports